import {useState} from "react";
import MyRoute from "./MyRoute";
import './OtherDetalis.css';


export default ({data, setData, page, setPage}) => {

    function clickOnHead (number) {
        setPage(number);
    }


    return (
    <>
        <div className="HeadOfOtherDetalisHead">

            <div className={ page < 5 ? "HeadOfOtherDetalisbooton" : "HeadOfOtherDetalistop" }>
                <p className={page === 1 ? "route_page" : ""} onClick={() => clickOnHead(1)}> שאר פרטים </p>
                <p className={page === 2 ? "route_page" : ""} onClick={() => clickOnHead(2)}>דרכון</p>
                <p className={page === 3 ? "route_page" : ""} onClick={() => clickOnHead(3)}> יצירת קשר </p>
                <p className={page === 4 ? "route_page" : ""} onClick={() => clickOnHead(4)}>נוסע מתמיד</p>
            </div>

            <div className={ page < 5 ? "HeadOfOtherDetalistop" : "HeadOfOtherDetalisbooton" } >
                <p className={page === 5 ? "route_page" : ""} onClick={() => clickOnHead(5)} >כרטיס אשראי</p>
                <p className={page === 6 ? "route_page" : ""} onClick={() => clickOnHead(6)} >ויזה</p>
                <p className={page === 7 ? "route_page" : ""} onClick={() => clickOnHead(7)} >הערות</p>
                <p className={page === 8 ? "route_page" : ""} onClick={() => clickOnHead(8)} >העדפות</p>
            </div>

        </div>

        <MyRoute page={page} data={data} setData={setData} />
        
    </>
    );
}